import { alpha } from "@mui/material";
import { ColorsConstants } from "../../cssUtils/constants";

// Values mirror voice.models.CallSession.Status
export const STATUS_OPTIONS = [
  { label: "Ringing", value: "ringing" },
  { label: "Answered", value: "answered" },
  { label: "Completed", value: "ended" },
  { label: "Missed", value: "missed" },
  { label: "Rejected", value: "rejected" },
  { label: "Failed", value: "failed" },
];

// Values mirror voice.models.TenantVoiceConfig.ResponseMode
export const AGENT_OPTIONS = [
  { label: "AI Bot", value: "ai_bot" },
  { label: "Human Agent", value: "agent" },
];

export const getStatusLabel = (status) =>
  STATUS_OPTIONS.find((o) => o.value === status)?.label || status || "Unknown";

export const getAgentLabel = (mode) =>
  AGENT_OPTIONS.find((o) => o.value === mode)?.label || "-";

const tint = (color) => ({ backgroundColor: alpha(color, 0.12), color });

export const getStatusChipSx = (status) => {
  switch (status) {
    case "ended":
    case "answered":
      return tint(ColorsConstants.successText);
    case "missed":
      return { backgroundColor: "warning.light", color: "warning.contrastText" };
    case "rejected":
    case "failed":
      return tint(ColorsConstants.error);
    default:
      return tint(ColorsConstants.secondaryBackgroundColor);
  }
};

export const formatDuration = (sec) => {
  if (sec === null || sec === undefined) return "-";
  const s = Math.round(sec);
  if (s < 60) return `${s}s`;
  const m = Math.floor(s / 60);
  if (m < 60) return `${m}m ${s % 60}s`;
  return `${Math.floor(m / 60)}h ${m % 60}m`;
};

// CallEvent.event_type values sent by botbridge_sip (see voice/views.py)
const EVENT_LABELS = {
  call_started: "Call started",
  call_answered: "Answered",
  call_missed: "Missed",
  call_ended: "Call ended",
  call_failed: "Call failed",
  call_recorded: "Recording saved",
};

export const getEventLabel = (type) =>
  EVENT_LABELS[type] ||
  (type || "Event").replace(/_/g, " ").replace(/^\w/, (c) => c.toUpperCase());
